import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';

import {AuthService} from 'src/app/modules/shared/services/auth.service';
import {AppLoadingEventsEmitter} from 'src/app/modules/shared/events/loading.events';
import {NotificationsService} from 'src/app/modules/shared/services/notification.service';
import {LocalisationService} from 'src/app/modules/shared/services/localisation.service';
import {Languages} from '../../../shared/enums/languages';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResetPasswordComponent implements OnInit {
    resetPasswordForm: FormGroup = new FormGroup({
        password: new FormControl('', [Validators.required, Validators.minLength(5)]),
        repeatPassword: new FormControl('', [Validators.required, Validators.minLength(5)])
    });
    code: string;
    subscriptions: Subscription[] = [];
    languages = Object.keys(Languages).map(k => Languages[k]);

    constructor(
        private readonly route: ActivatedRoute,
        private readonly authService: AuthService,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly notificationsService: NotificationsService,
        private readonly localisationService: LocalisationService,
        private readonly router: Router
    ) {
    }

    ngOnInit() {
        this.subscriptions.push(
            this.route.queryParams.subscribe(params => {
                const code = params['code'];

                if (code) {
                    this.code = code;
                } else {
                    this.router.navigate(['/']);
                }
            })
        );
    }

    onChangePassword() {
        const password: string = this.resetPasswordForm.controls['password'].value;

        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.authService
            .resetPassword({
                password,
                reset_code: this.code
            })
            .subscribe(
                () => {
                    this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);

                    this.router.navigate(['/login']);

                    this.notificationsService.success(this.localisationService.localise('auth_password_changed_successfully'));
                },
                () => {
                    this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);

                    this.resetPasswordForm.controls['password'].setValue(null);
                    this.resetPasswordForm.controls['repeatPassword'].setValue(null);

                    this.notificationsService.error(this.localisationService.localise('auth_reset_token_expires'));
                }
            );
    }

    onLanguageSelected(locale: Languages) {
        let url = this.router.url;
        url = url.substr(0, (url.indexOf('?') !== -1 ? url.indexOf('?') : url.length));

        window.location.href = url + '?lang=' + locale.toLocaleLowerCase();
    }

    flagIcon(language: Languages): string {
        switch (language) {
            case Languages.English:
                return 'us';
            default:
                return language.toLowerCase();
        }
    }
}
